<mat-button-toggle
  class="toolbar-button"
  (click)="toggleZoomPanel()"
  [checked]="isZoomPanelOpened$ | async"
  [matTooltip]="tooltipText"
>
  <mat-icon [h3CustomIcon]="zoomPanelIcon"></mat-icon>
</mat-button-toggle>
